import React,{useRef,useState} from 'react'
import {Validation} from './Validation.tsx'
import Input from '../Parts/Input'
import Style from './Body.module.css'

const Body = () => {
  const [errorValue , setErrorValue] = useState(false);

  const firstName = useRef();
  const lastName = useRef();
  const email = useRef();
  const password = useRef();

  //for reseting values
  const reset = ()=>{
    firstName.current.value = "";
    lastName.current.value = "";
    email.current.value = "";
    password.current.value = "";
  }
  const error=()=>{
    setErrorValue(true)
    reset();
    email.current.placeholder = "email@example/com"

  }
  //for handling form submit request
  const handleSubmit = async(e) =>{
    e.preventDefault();
    const data = {
      firstName:firstName.current.value,
      lastName:lastName.current.value,
      email:email.current.value,
      password:password.current.value
    }
    let response = await Validation(data);
    if(response.success){
      window.alert('complete');
    }
    if(response.error) {
      error()
    }
    console.log(response)
  }
  return (
    <main className={Style.FormBody}>
        <div className={Style.OfferCard}>
        <span>Try it free 7 days</span> then $20/mo. thereafter
        </div>
      <form onSubmit={e=>handleSubmit(e)}>
              <Input 
              type="text"
              id="Firstname"
              className="Firstname"
              placeholder="First Name"
              ErrorMessage="First Name cannot be empty"
              ref={firstName}
              error={errorValue}
              />
              <Input 
              type="text"
              id="Lastname"
              className="Lastname"
              placeholder="Last Name"
              ErrorMessage="Last Name cannot be empty"
              ref={lastName}
              error = {errorValue}
              />
              <Input 
              type="email"
              id="email"
              className="email"
              placeholder="Email Address"
              ErrorMessage="Looks like this is not an email"
              error = {errorValue}
              ref={email}
              />
              <Input 
              type="password"
              id="password"
              className="password"
              placeholder="Password"
              ErrorMessage="Password cannot be empty"
              error = {errorValue}
              ref={password}
              />
    <button type={`submit`} className={Style.btn_submit}>Claim your free trial</button> 

    <p className={Style.Terms}>By clicking the button, you are agreeing to our <span>Terms and Services</span></p>
    </form>
    </main>
  )
}

export default Body